module.exports = __webpack_public_path__ + "static/media/transporter.37133ad0.jpg";